var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompareArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "compare_arrows",
    clipPath: "url(#clip0_12350_154258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.01 14.5025H3C2.45 14.5025 2 14.9525 2 15.5025C2 16.0525 2.45 16.5025 3 16.5025H9.01V18.2925C9.01 18.7425 9.55 18.9625 9.86 18.6425L12.64 15.8525C12.83 15.6525 12.83 15.3425 12.64 15.1425L9.86 12.3525C9.55 12.0325 9.01 12.2625 9.01 12.7025V14.5025ZM14.99 12.2925V10.5025H21C21.55 10.5025 22 10.0525 22 9.50247C22 8.95247 21.55 8.50247 21 8.50247H14.99V6.71247C14.99 6.26247 14.45 6.04247 14.14 6.36247L11.36 9.15247C11.17 9.35247 11.17 9.66247 11.36 9.86247L14.14 12.6525C14.45 12.9625 14.99 12.7425 14.99 12.2925Z",
    fill: "#667085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12350_154258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareArrows);
export default __webpack_public_path__ + "static/media/compareArrows.3a0640f9f77094f6e0ce6baa08278823.svg";
export { ForwardRef as ReactComponent };